import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { RecaptchaV3Module } from 'ng-recaptcha';
import { CompleteProfileModalComponent } from './components/complete-profile-modal/complete-profile-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RecaptchaV3Module, RouterOutlet, HeaderComponent, FooterComponent, SidebarComponent, CompleteProfileModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Pashuposhan-ui';
}
